import { cn } from "lib/utils";

function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn("animate-pulse rounded-lg bg-nysmah-light-bg", className)}
      {...props}
    />
  );
}

export { Skeleton };
